var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRightBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-1119 -414) translate(265 118) translate(854 296)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M10.504 3.773l.99-.966c.42-.41 1.099-.41 1.514 0l8.677 8.453c.42.41.42 1.07 0 1.475l-8.677 8.458c-.42.41-1.098.41-1.514 0l-.99-.966c-.425-.413-.416-1.087.017-1.492l5.38-4.995H3.07C2.478 13.74 2 13.275 2 12.696v-1.392c0-.579.478-1.044 1.071-1.044h12.83l-5.38-4.995c-.437-.405-.446-1.08-.017-1.492z",
    transform: "translate(-1119 -414) translate(265 118) translate(854 296)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightBold);
export default __webpack_public_path__ + "static/media/icon-arrow-right-bold.eb61e56f.svg";
export { ForwardRef as ReactComponent };